import React from 'react';
import { useSelector } from 'react-redux';
import { getRegion } from 'utils/Region';
import { pushSelectContentEvent } from 'utils/analytics/pushSelectContentEvent';
import useMenuRedirect from 'containers/Menu/hooks/useMenuRedirect';
import { useVerifyIsMobile } from '../../../../../../hooks/useVerifyIsMobile';
//-----------------------------------------------------------------------
import { FadeInImage } from '../../../../../../components/FadeInImage';
import { RANKING_IMAGES } from './constants';
import './style.scss';
import useRenderChapas from '../../../../../../hooks/useRenderChapas';
import { useNavigate } from 'react-router-dom';
import { getContentListV1 } from 'utils/homologacion/homologacion';
import { IMG_SIZE } from 'utils/homologacion/contants';

export const RankingCard = ({ contentInfo, rankingPlace, carouselTitle, contentPosition }) => {
  const navigate = useNavigate();
  const assets = useSelector(state => state.asset);
  const { isMobile } = useVerifyIsMobile(768);
  const { renderLabel } = useRenderChapas();
  const { nodesSelected } = useMenuRedirect();

  const handleCardClick = e => {
    e.stopPropagation();

    pushSelectContentEvent(contentInfo, nodesSelected, carouselTitle, contentPosition);

    //Redireccionamiento
    navigate(
      `/${getRegion()}/vcard/homeuser/${getContentListV1.titleUri(contentInfo)}/${
        contentInfo.id
      }`,
    );
  };

  if (rankingPlace > 9) return null;

  return (
    <div
      className={`${rankingPlace === 9 ? 'ranking-card last' : 'ranking-card'}`}
      onClick={handleCardClick}
    >
      <div
        className={`${
          rankingPlace === 0 ? 'ranking-card__top first' : 'ranking-card__top'
        }`}
      >
        <img src={assets[RANKING_IMAGES[rankingPlace]]} alt="ranking place" />
      </div>
      <div className="ranking-card__image">
        {renderLabel(contentInfo)}
        <FadeInImage
          imageAlt={'clarovide'}
          imageSrc={
            isMobile ?  getContentListV1?.getImage(contentInfo,IMG_SIZE?.MEDIUM) : getContentListV1?.getImage(contentInfo,IMG_SIZE?.LARGE)
          }
          width={isMobile ? 157 : 258}
          height={isMobile ? 152 : 145}
          classNames={['ranking-card__img']}
        />
      </div>
    </div>
  );
};
